import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const ServiceOffert = lazy(() => import("@/pages/offert/ServiceOffert"));

export const Route = createFileRoute("/laddstolpar/offert")({
  head: () => seoHead("/laddstolpar/offert"),
  component: () => <ServiceOffert service="laddstolpar" />,
});
